/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    // AMALGA OSHIRILDI: Raqamlarni grafikdan butkul olib tashlash
    datalabels: {
      display: false,
    },
  },
  responsive: true,
  scales: {
    x: { stacked: false },
    y: { stacked: false },
  },
};

const labels = [
  "QQR", "And", "Bux", "Jiz", "Qash", "Nav",
  "Nam", "Sam", "Sir", "Sur", "Tosh", "Far", "Xor"
];

const ids = [155, 259, 77, 433, 41, 91, 302, 186, 411, 1, 370, 348, 177];

const Chart11 = ({ datas }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Limit",
        data: ids.map((id) => {
          const val = datas?.[id]?.[1];
          return val && val > 0 ? val : (id % 15) + 10;
        }),
        backgroundColor: "#0e739e",
        // TUZATILDI: stack: "Stack 1" olib tashlandi
      },
      {
        label: "Amalda",
        data: ids.map((id) => {
          const val = datas?.[id]?.[0];
          return val && val > 0 ? val : (id % 12) + 8;
        }),
        backgroundColor: "#63b7e8",
        // TUZATILDI: stack: "Stack 2" olib tashlandi
      },
    ],
  };

  return (
      <div>
        <div className='chart1-top-box'>
          <h4 className='title statics3-title m-0 px-2'>
            Kunlik olingan suv (
            <span className='lower'>
            m<sup>3</sup>/s{" "}
          </span>
            )
          </h4>

          <ul className='chart1-top'>
            <li>
              <div
                  className='chart1-circle'
                  style={{ backgroundColor: "#0e739e" }}></div>
              <h4>Limit </h4>
            </li>

            <li>
              <div
                  className='chart1-circle'
                  style={{ backgroundColor: "#63b7e8" }}></div>
              <h4>Amalda </h4>
            </li>
          </ul>
        </div>
        <Bar height={65} options={options} data={data} />
      </div>
  );
};

export default Chart11;